import { useRouter } from 'next/router';

export const useIsUpdateThemeQueryParamTrue = () => {
  const router = useRouter();
  const { updateTheme } = router.query;
  return updateTheme === 'true';
};
